module.exports = __webpack_public_path__ + "static/media/dragIcon.ca41c349.svg";